<template>
  <vue-drr
    :parent="true"
    :rotatable="true"
    :w="w"
    :h="h"
    :x="x"
    :y="y"
    :angle="r"
    ref="widget"
    class="widget-container"
    @dragstop="dragStop"
    @rotatestop="rotateStop"
    @resizestop="resizeStop"
    :style="{
      backgroundColor: backgroundColor,
      paddingLeft: `${paddingLeft}px`,
      paddingTop: `${paddingTop}px`,
      paddingRight: `${paddingRight}px`,
      paddingBottom: `${paddingBottom}px`,
      zIndex: zIndex
    }"
  >
    <div
      class="widget animated bounceIn"
      :id="`widget${id}`"
      @click="setActiveWidget"
      :style="{
        justifyContent: justifyContent,
        alignItems: alignItems
      }"
    >
      <img
        src="@/assets/images/placeholder_img_200x200.jpg"
        class="w-100"
      />
    </div>
  </vue-drr>
</template>

<script>
import VueDrr from 'vue-drr';
import WidgetMixin from './WidgetMixin';
import { mapWidgets } from './WidgetUtils';

export default {
  components: {
    'vue-drr': VueDrr,
  },
  mixins: [WidgetMixin],
  computed: {
    ...mapWidgets(
      [
        {
          path: '',
          key: 'name',
        },
        {
          path: '',
          key: 'icon',
        },
        {
          path: '',
          key: 'component',
        },
        {
          path: 'dataImage',
          key: 'src',
        },
        {
          path: 'style',
          key: 'justifyContent',
        },
        {
          path: 'style',
          key: 'alignItems',
        },
        {
          path: 'style',
          key: 'deformation',
        },
        {
          path: 'style',
          key: 'zIndex',
        },
        {
          path: 'style',
          key: 'paddingLeft',
        },
        {
          path: 'style',
          key: 'paddingTop',
        },
        {
          path: 'style',
          key: 'paddingRight',
        },
        {
          path: 'style',
          key: 'paddingBottom',
        },
        {
          path: 'style',
          key: 'backgroundColor',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
        {
          path: 'style',
          key: 'r',
        },
      ],
    ),
  },
  created() {
    const payload = {
      data: [],
    };

    if (this.deformation === 0) {
      payload.data.push({
        path: 'style',
        key: 'deformation',
        value: 0,
      });
      payload.data.push({
        path: 'style',
        key: 'justifyContent',
        value: 'center',
      });
      payload.data.push({
        path: 'style',
        key: 'alignItems',
        value: 'center',
      });
    }

    this.$store.dispatch(`widget${this.id}/UPDATE_WIDGET`, payload);
  },
};
</script>

<style scoped>

</style>
